export default __webpack_public_path__ + "static/media/button_enable.17792420.mp3";